import React, { useState } from 'react';
import { useInfiniteScroll } from '../../../../../common/hooks/use-infinite-scroll';
import { TemplateModel } from '@mm/state/model/TemplateModel';
import { TextLink } from '@mm/components';
import { CopyTemplateCode } from '../../components/CopyTemplateCode/CopyTemplateCode';
import CreateBotOrExtendByTemplate from '../../components/CreateBotOrExtendByTemplate/CreateBotOrExtendByTemplate';
import { TemplateBlocks } from '../../components/TemplateBlocks/TemplateBlocks';
import { useTemplateFetchHook } from '../../hooks/use-template-fetch-hook';
import './TemplateLibraryPanel.scss';

export const TemplateLibraryPanel = () => {
  const { templates, fetchMore, moreToFetch } = useTemplateFetchHook(true);
  useInfiniteScroll<HTMLDivElement>({
    fetchMore,
    fetchDisabled: !moreToFetch,
    useChatbotEditorPageContentContainer: true,
    scrollEndOffset: 500,
  });

  const [searchToken, setSearchToken] = useState<string | undefined>(undefined);

  const [isCreateOrExtendBot, setIsCreateOrExtendBot] = useState(false);
  const [isCopyTemplateCode, setIsCopyTemplateCode] = useState(false);
  const closeModal = () => {
    setSearchToken(undefined);
    setIsCreateOrExtendBot(false);
    setIsCopyTemplateCode(false);
  };

  const openCopyTemplateCode = (tempalteId: number, searchCode: string) => {
    setSearchToken(searchCode);
    setIsCopyTemplateCode(true);
  };

  const openCreateOrExtendBotDialog = (
    templateId: number,
    searchCode: string,
  ) => {
    setSearchToken(searchCode);
    setIsCreateOrExtendBot(true);
  };

  return (
    <div>
      <TextLink className="templates-library__info">
        Browse Customers.ai's verified templates for something that fits your
        industry, vertical, and use case.
      </TextLink>

      <TemplateBlocks>
        {templates.map((model: TemplateModel) => (
          <TemplateBlocks.Item
            key={model.id}
            onClick={openCreateOrExtendBotDialog}
            onGetCode={openCopyTemplateCode}
            title={model.name}
            isShared
            searchToken={model.searchToken}
            subTitle="By Customers.ai"
            details={model.description}
            img={model.asset && model.asset.urls.medium}
            id={model.id}
          />
        ))}
      </TemplateBlocks>
      {isCreateOrExtendBot && searchToken !== undefined && (
        <CreateBotOrExtendByTemplate
          onClose={closeModal}
          searchToken={searchToken}
        />
      )}
      {isCopyTemplateCode && searchToken !== undefined && (
        <CopyTemplateCode onClose={closeModal} searchToken={searchToken} />
      )}
    </div>
  );
};
